import { batchToggleSyncMaterial } from '@/api/worker'

export default {
    props: {
        showBatchSyncForm: {
            type: Boolean,
            required: true
        },
        ids: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            labelCol: {span: 6},
            wrapperCol: {span: 16},
            loading: false,
            form: {
                is_sync_material: 1,
            },
        }
    },
    mounted() {},
    watch: {
        showBatchSyncForm(val) {
            if (val) {
                this.form.is_sync_material = 1
            }
        }
    },
    methods: {
        submit() {
            if (!this.ids.length) {
                this.$message.warning('请先选择优化师')
                return
            }
            this.loading = true
            batchToggleSyncMaterial({
                ids: this.ids,
                is_sync_material: this.form.is_sync_material,
            }).then(res => {
                this.$message.destroy()
                if (res && res.code === 0) {
                    this.$message.success('设置成功')
                    this.$emit('success')
                    this.close()
                } else {
                    this.$message.error(res.message)
                }
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        close() {
            this.$emit('update:showBatchSyncForm', false)
        },
    }
}